import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800" data-id="element-121">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-122">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-123">
          <div data-id="element-124">
            <h3 className="text-white font-bold text-lg mb-2" data-id="element-125">
              Amazon FBA desde Cero
            </h3>
            <p className="text-sm" data-id="element-126">Guía práctica para vendedores hispanos.</p>
          </div>
          <div className="text-sm leading-relaxed" data-id="element-127">
            <p className="mb-4" data-id="element-128">
              Este material es exclusivamente educativo e informativo. No
              constituye asesoría legal, fiscal, financiera ni de inversión.
              Consulta con profesionales calificados antes de tomar decisiones
              comerciales.
            </p>
            <p data-id="element-129">
              Amazon, FBA y Seller Central son marcas registradas de Amazon.com,
              Inc. Este producto no está afiliado ni respaldado por Amazon.
            </p>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4 text-sm" data-id="element-130">
          <p data-id="element-131">© 2026 — Todos los derechos reservados</p>
          <p data-id="element-132">Contacto: hola@tudominio.com</p>
        </div>
      </div>
    </footer>;
}